import { Navigate } from "react-router-dom";

// Dashboard
import Dashboard from "../pages/dashboard";

// AuthPages
import Login from "../pages/authentication/login";
import Register from "../pages/authentication/register";
import ForgetPassword from "../pages/authentication/forgetpassword";
import Logout from "../pages/authentication/logout";
import UserProfile from "../pages/authentication/user-profile";
import Otpscreen from "../pages/authentication/otpscreen";
import StoreSettings from "../pages/store-settings/storeSettings";
import Analytics from "../pages/analytics/analytics";
import ManageProducts from "../pages/manage-products/manageProducts";
import WarrantyRegistrations from "../pages/warranty-registrations";
import Store from "../pages/store/store";
import WarrantyPage from "../pages/store/WarrantyPage";
import CreateStore from "../pages/store-settings/create-store";
import AdminTenants from "../pages/admin/tenants";

const authProtectedRoutes = [
  // Index - dashboard
  { path: "/", component: <Dashboard /> },
  { path: "*", component: <Navigate to="/dashboard" /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/store-settings", component: <StoreSettings /> },
  { path: "/analytics", component: <Analytics /> },
  { path: "/manage-products", component: <ManageProducts /> },
  { path: "/warranty-registrations", component: <WarrantyRegistrations /> },
  { path: "/admin/tenants", component: <AdminTenants /> },

  // User Profile
  { path: "/user-profile", component: <UserProfile /> },
];

const publicRoutes = [
  //Auth Pages
  { path: "/login", component: <Login /> },
  { path: "/register", component: <Register /> },
  { path: "/forgot-password", component: <ForgetPassword /> },
  { path: "/logout", component: <Logout /> },
  { path: "/otp-screen", component: <Otpscreen /> },
  { path: "/create-store", component: <CreateStore /> },
  { path: "/warranty-registration", component: <WarrantyPage /> },
  { path: "/warranty", component: <WarrantyPage /> },
  { path: "/:url/warranty-registration", component: <WarrantyPage /> },
  { path: "/:url/warranty", component: <WarrantyPage /> },
  { path: "/:url", component: <Store /> },
];

export { authProtectedRoutes, publicRoutes };
